module.exports = __webpack_public_path__ + "static/media/bureau_paris.e00bcf31.jpg";